module.exports = __webpack_public_path__ + "img/CRM.97f6e861.png";